import { useBoolean } from '@dreryk/react-common';

import { PatientMedicalInformationRemoveModal } from './PatientMedicalInformationRemoveModal';

type PatientMedicalInformationRemoveModalOpenerRenderProps = Readonly<{ openModal: VoidFunction }>;
type PatientMedicalInformationRemoveModalOpenerProps = Readonly<{
   medicalInformationId: number;
   onRemoveSuccess: VoidFunction;
   children: (renderProps: PatientMedicalInformationRemoveModalOpenerRenderProps) => JSX.Element;
}>;

export const PatientMedicalInformationRemoveModalOpener = (
   props: PatientMedicalInformationRemoveModalOpenerProps
): JSX.Element => {
   const [{ setFalse: closeModal, setTrue: openModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}

         {modalOpened ? (
            <PatientMedicalInformationRemoveModal
               medicalInformationId={props.medicalInformationId}
               onClose={closeModal}
               onRemoveSuccess={props.onRemoveSuccess}
            />
         ) : null}
      </>
   );
};
